import { listVal } from "@paroi/data-formatters-lib";
import type { CreateOrganizationInput, UpdateOrganizationInput } from "../domain/organization";
import { type PaginationOptions, fetchQuery } from "../shared/http-client";
import { type Organization, formatToOrganization } from "./organization.formatter";

export async function fetchOrganizationsAPI(options: PaginationOptions): Promise<Organization[]> {
  const res = await fetchQuery(`organizations?limit=${options.limit}&page=${options.page}`);
  return listVal(res.data, formatToOrganization);
}

export async function fetchOneOrganizationAPI(id: string): Promise<Organization> {
  const res = await fetchQuery(`organizations/${id}`);
  return formatToOrganization(res.data);
}

export async function createOrganizationAPI(input: CreateOrganizationInput): Promise<void> {
  const jsonBody: Record<string, unknown> = {
    owner_name: input.ownerName,
    owner_email: input.ownerEmail,
    name: input.name,
    acronym: input.acronym,
    description: input.description,
    address: input.address,
    phone: input.phone,
  };
  let body: FormData | string = JSON.stringify(jsonBody);
  if (input.logo) {
    const formData = new FormData();
    formData.append("logo", input.logo);
    for (const [key, value] of Object.entries(jsonBody)) {
      formData.append(key, String(value));
    }
    body = formData;
  }
  await fetchQuery("organizations", {
    method: "POST",
    body,
  });
}

export async function updateOrganizationAPI(
  id: string,
  input: UpdateOrganizationInput,
): Promise<void> {
  const propertiesToEdit: Record<string, unknown> = {};
  if (input.name !== undefined) propertiesToEdit.name = input.name;
  if (input.acronym !== undefined) propertiesToEdit.acronym = input.acronym;
  if (input.description !== undefined) propertiesToEdit.description = input.description;
  if (input.enabled !== undefined) propertiesToEdit.enabled = input.enabled;
  if (input.ownerEmail !== undefined) propertiesToEdit.owner_email = input.ownerEmail;
  if (input.ownerName !== undefined) propertiesToEdit.owner_name = input.ownerName;
  if (input.phone !== undefined) propertiesToEdit.phone = input.phone;
  if (input.address !== undefined) propertiesToEdit.address = input.address;
  if (Object.keys(propertiesToEdit).length === 0) return;
  let body: FormData | string = JSON.stringify(propertiesToEdit);
  if (input.logo) {
    const formData = new FormData();
    formData.append("logo", input.logo);
    for (const [key, value] of Object.entries(propertiesToEdit)) {
      formData.append(key, String(value));
    }
    body = formData;
  }
  await fetchQuery(`organizations/${id}`, {
    method: "POST",
    body,
  });
}

export async function deleteOrganizationAPI(id: string): Promise<void> {
  await fetchQuery(`organizations/${id}`, {
    method: "DELETE",
  });
}
